





























































import Vue, { PropType } from "vue";
import Draggable from "vuedraggable";
type TreeItem = {
    id: number;
    name: string;
    children: TreeItem[];
};
export default Vue.extend({
    name: "TreeviewNode",
    components: {
        Draggable,
    },
    props: {
        level: {
            type: Number,
            default: 0,
        },
        value: {
            type: Object as PropType<TreeItem>,
            default: (): TreeItem => ({
                id: 0,
                name: "",
                children: [],
            }),
        },
        root: {
            type: Boolean,
            default: (): boolean => false,
        },
        group: {
            type: String,
            default: null,
        },
        expandIcon: {
            type: String,
            default: "mdi-menu-down",
        },
        activatable: {
            type: Boolean,
            default: false,
        },
        selected: {
            type: Number,
            default: null,
        },
        returnObject: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            open: false,
            active: false,
            localValue: { ...this.value } as TreeItem,
        };
    },
    computed: {
        hasChildren(): boolean {
            return this.value.children != null && this.value.children.length > 0;
        },
        isDark(): boolean {
            return this.$vuetify.theme.dark;
        },
        appendLevel(): number {
            return this.level + (this.hasChildren ? 0 : 1);
        },
    },
    watch: {
        value(value): void {
            this.localValue = { ...value };
        },
        selected(value) {
            this.active = (value == this.value.id);
        },
    },
    methods: {
        clickNode(): void {
            if (this.value.children.length > 0)
                this.open = !this.open;
            if (this.activatable) {
                this.active = !this.active;
                if (this.active) {
                    this.$emit("updateActive", (this.returnObject ? this.value : this.value.id));
                }
            }
        },
        updateActive(value): void {
            if (this.activatable) {
                this.$emit("updateActive", value);
            }
        },
        updateValue(value: TreeItem[]): void {
            this.localValue.children = [...value];
            this.$emit("input", this.localValue);
        },
        updateChildValue(value: TreeItem): void {
            const index = this.localValue.children.findIndex(
                (c) => c.id === value.id
            );
            this.$set(this.localValue.children, index, value);
            this.$emit("input", this.localValue);
        },
    },
});
